import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLogoComponent } from './components/default-logo/default-logo.component';
import { DefaultLogoVersionComponent } from './components/default-logo-version/default-logo-version.component';
import { CoreModule } from '../core/core.module';
import { Common2Module } from 'projects/common/src/app/app.module';
import { LoginTriesModalComponent } from '../login/components/login-tries-modal/login-tries-modal.component';

@NgModule({
  declarations: [
    DefaultLogoComponent,
    DefaultLogoVersionComponent,
    LoginTriesModalComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    Common2Module.forRoot(),
  ],
  exports: [
    DefaultLogoComponent,
    DefaultLogoVersionComponent
  ]
})
export class LogoModule { }
